
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
components: {
XHeader
},
created(){
this. check();
},
methods: {
show_menu(){
this.menu_on = !this.menu_on;
},
go_login(){
if(!this.isLogin()){
this.$router.push('/auth/login')
}else{
this.$router.push('/user/index')
}
},
go_info(){

this.$router.push('/user/index')
},
check(){
this.mobile=this.getUserMobile();
if(this.isLogin()){
this.login_in=true;
}
}
},
data(){
return{
menu_on: false,
login_in: false,
mobile:{}
}
}
}



// WEBPACK FOOTER //
// ./src/components/headers.vue